import { Zap, Github } from "lucide-react";
import { AppStoreBadge } from "./AppStoreBadge";
import { GooglePlayBadge } from "./GooglePlayBadge";
import { WEB_POS_DEMO_URL } from "@/lib/links";

export const Header = ({ t, lang, setLang }) => (
  <header data-testid="site-header" className="sticky top-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
      <a href="#" data-testid="header-logo" className="flex items-center gap-2 font-heading font-bold text-white text-lg">
        <span className="w-8 h-8 rounded-lg bg-[#F7931A] flex items-center justify-center shadow-[0_0_15px_rgba(247,147,26,0.5)]">
          <Zap className="w-4 h-4 text-black" fill="currentColor" />
        </span>
        Lightning POS
      </a>
      <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-400">
        <a href="#features" data-testid="nav-features-link" className="hover:text-white transition-colors">{t.nav.features}</a>
        <a href="#security" data-testid="nav-security-link" className="hover:text-white transition-colors">{t.nav.security}</a>
        <a href="#waitlist" data-testid="nav-waitlist-link" className="hover:text-white transition-colors">{t.nav.waitlist}</a>
      </nav>
      <div className="flex items-center gap-3">
        <button
          data-testid="language-toggle-button"
          onClick={() => setLang(lang === "es" ? "en" : "es")}
          className="text-xs font-bold tracking-widest text-zinc-400 hover:text-white border border-white/10 rounded-full px-3 py-1.5 transition-colors"
        >
          {lang === "es" ? "EN" : "ES"}
        </button>
        <a
          href="https://github.com/fernando-mendoza"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-github-link"
          className="text-zinc-400 hover:text-white transition-colors"
        >
          <Github className="w-5 h-5" />
        </a>
        <AppStoreBadge
          t={t}
          lang={lang}
          className="h-9"
          anchorClassName="hidden sm:inline-flex"
          testId="header-app-store-badge"
        />
        {/* El segundo badge sólo desde lg: los dos juntos no caben con el nav en md. */}
        <GooglePlayBadge
          t={t}
          lang={lang}
          className="h-9"
          anchorClassName="hidden lg:inline-flex"
          testId="header-google-play-badge"
        />
        <a
          href={WEB_POS_DEMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-demo-link"
          className="hidden lg:inline-flex bg-[#F7931A] text-black text-sm font-semibold px-4 py-2 rounded-lg hover:bg-[#E88210] transition-colors shadow-[0_0_15px_rgba(247,147,26,0.3)]"
        >
          {t.nav.demo}
        </a>
      </div>
    </div>
  </header>
);
